var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlyNameLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFDEA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.4,639.4l-73.2-143.8v143.7h-34.8l0.2-219.5h34.6l92.1,182.5l91.1-183.7h34.4V639h-34.4V495.6l-72,143.8 H283.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.4,639.1l119-218.6h26.3l118,218.8h-38.7l-24.8-46.9l-16.1-29.9l-52-93.2l-92,169.8L463.4,639.1 L463.4,639.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M919.2,420.2h38.7L839.9,639h-26.3l-119-218.6h39.7l92,169.8L919.2,420.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 997.3,
    y: 419.9,
    className: "st0",
    width: 34.4,
    height: 219.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1101.6,
    y: 419.9,
    className: "st0",
    width: 34.4,
    height: 219.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1369.2,587.8v-168h34.6v219.4h-34.9l-137.9-166.2v166.2h-35.8V419.8h32.9L1369.2,587.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1647.2,451.1h-131.3c-16.6,0.1-24.8,8.3-24.8,24.5v109.5c-0.1,15.2,8.8,22.8,26.7,22.8H1647l0.2,31.4 l-139.2-0.2c-34.7,0.1-52-15.5-52-46.9l0.2-125.5c0-31.5,17.3-47.2,51.8-47.2H1647L1647.2,451.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1710.1,
    y: 419.9,
    className: "st0",
    width: 34.4,
    height: 219.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyNameLogo);
export default __webpack_public_path__ + "static/media/only_name_LOGO.403b3169dec9c79b57e3a924e87010b1.svg";
export { ForwardRef as ReactComponent };